import { apiService } from "@/core/services";

export const ROLE_PERMISSION = {
  getPermissions,
  getPermission,
  createPermission,
  updatePermission,
  deletePermission,
};

const URL = {
  PERMISSION: "permissions",
  GET: "get",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
};

function getPermissions(data) {
  let requestOptions = {
    params: {
      role_name: data.roleName,
      page_size: data.perPage,
      page_num: data.page,
    },
  };

  return apiService().get(`/${URL.PERMISSION}/${URL.GET}`, requestOptions);
}
function getPermission(id) {
  return apiService().get(`/${URL.PERMISSION}/${URL.GET}/${id}`);
}
function createPermission(data) {
  let requestBody = {
    roleName: data.roleName,
    adGroupName: data.adGroupName,
    modules: data.modules,
    status: Number(data.status),
  };

  return apiService().post(`/${URL.PERMISSION}/${URL.CREATE}`, requestBody);
}
function updatePermission(id, data) {
  let requestBody = {
    roleName: data.roleName,
    adGroupName: data.adGroupName,
    modules: data.modules,
    status: Number(data.status),
  };
  return apiService().put(
    `/${URL.PERMISSION}/${URL.UPDATE}/${id}`,
    requestBody
  );
}
function deletePermission(id) {
  return apiService().delete(`/${URL.PERMISSION}/${URL.DELETE}/${id}`);
}
